import { useEffect } from 'react';

/**
 * Prefetch profil rute na hover/intent (živi u App sloju, ne u shared).
 */

/**
 * Registruje globalne pointer/focus listenere za lazy-load `UserProfilePage` chunk-a.
 * Aktivira se na linkove čiji pathname počinje sa `/profil`.
 * @returns {void}
 */
export function usePrefetchUserProfileOnIntent() {
  useEffect(() => {
    let prefetchStarted = false;

    const warmup = () => {
      if (prefetchStarted) return;
      prefetchStarted = true;
      import('@/features/user/profile/UserProfilePage').catch(() => {});
    };

    const onIntent = (event) => {
      const a = event.target?.closest?.('a[href]');
      if (!a) return;
      const href = a.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      try {
        const u = new URL(href, window.location.origin);
        if (u.origin !== window.location.origin) return;
        if (u.pathname.startsWith('/profil')) warmup();
      } catch {
        /* ignore */
      }
    };

    document.addEventListener('pointerdown', onIntent, true);
    document.addEventListener('focusin', onIntent, true);
    return () => {
      document.removeEventListener('pointerdown', onIntent, true);
      document.removeEventListener('focusin', onIntent, true);
    };
  }, []);
}
